module.exports = __webpack_public_path__ + "static/media/event-services-img20.fe1f0d0a.jpg";